module.exports = __webpack_public_path__ + "img/arrow-down-active.e149d0bf.svg";